module.exports = __webpack_public_path__ + "static/media/studentdashboard-left.c0353ee6.png";